import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import SelectField from 'Shared/form/SelectField';
import { followupAppealActivityOptions } from './constants';
import CommonPatientFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';

const propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
};

const defaultProps = {};

function UpheldForm({ isFormDisabled }) {
    return (
        <Row>
            <CommonPatientFieldWrapper fieldName="referralAppealCreateFollowUpAppealActivity">
                {(commonProps) => (
                    <Col md={2}>
                        <SelectField
                            {...commonProps}
                            isDisabled={commonProps.disabled || isFormDisabled}
                            isClearable
                            label="Create a follow-up Appeal activity?"
                            options={followupAppealActivityOptions}
                            fieldName="details.scheduleFollowupAppeal"
                        />
                    </Col>
                )}
            </CommonPatientFieldWrapper>
        </Row>
    );
}

UpheldForm.propTypes = propTypes;
UpheldForm.defaultProps = defaultProps;

export default UpheldForm;
